/**
 * Возвращает куку с заданным именем
 *
 * @param {String} name - имя куки
 * @return {String}
 */
export const getCookie = (name) => {
    const matches = document.cookie.match(
        new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\\]\\+^])/g, '\\$1')}=([^;]*)`),
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
};

/**
 * Устанавливает куку с заданным именем, значением и опциями.
 *
 * @param {String} name - имя куки
 * @param {String|Object} value - значение куки
 * @param {Object} [options] - опций
 * @param {Number|Date} [options.expires] - Срок жизни (в днях, если число)
 * @param {String} [options.domain] - Домен
 * @param {String} [options.path] - Путь
 * @param {'strict'|'lax'|'none'} [options.samesite] - Политика SameSite
 */
export const setCookie = (name, value, options) => {
    const opts = { ...(options || {}) };

    // expires: число (дни) -> Date -> UTCString
    const rawExpires = opts.expires;

    if (typeof rawExpires === 'number' && rawExpires) {
        const date = new Date();
        date.setTime(date.getTime() + rawExpires * 24 * 60 * 60 * 1000);
        opts.expires = date.toUTCString();
    } else if (rawExpires instanceof Date) {
        opts.expires = rawExpires.toUTCString();
    }

    // domain по умолчанию: eTLD+1 (приближенно)
    if (!opts.domain) {
        const { hostname } = window.location;
        const lastDot = hostname.lastIndexOf('.');
        const beforeLastDot = hostname.lastIndexOf('.', lastDot - 1);
        const etldPlusOne = hostname.substring(beforeLastDot + 1);
        opts.domain = etldPlusOne;
    }

    // path по умолчанию
    if (!opts.path) {
        opts.path = '/';
    }

    const encodedValue = encodeURIComponent(value);
    let cookieStr = `${name}=${encodedValue}`;

    for (const [propName, propValue] of Object.entries(opts)) {
        cookieStr += `; ${propName}`;

        if (propValue !== true) cookieStr += `=${propValue}`;
    }

    document.cookie = cookieStr;
};
